import { useEffect, useMemo, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../services/firebase';
import type { UserNotification } from '../types';

export function useUserNotifications(userId: string | undefined) {
    const [notifications, setNotifications] = useState<UserNotification[]>([]);

    useEffect(() => {
        if (!userId) {
            setNotifications([]);
            return;
        }

        const notificationsQuery = query(
            collection(db, 'users', userId, 'notifications'),
            orderBy('createdAt', 'desc'),
        );

        const unsubscribe = onSnapshot(notificationsQuery, (snap) => {
            const items = snap.docs.map((notificationDoc) => ({
                id: notificationDoc.id,
                ...notificationDoc.data(),
            })) as UserNotification[];
            setNotifications(items);
        }, (error) => {
            console.error('Failed to subscribe to user notifications:', error);
            setNotifications([]);
        });

        return unsubscribe;
    }, [userId]);

    const unreadCount = useMemo(
        () => notifications.filter((notification) => !notification.read).length,
        [notifications],
    );

    return { notifications, unreadCount };
}
